import { useLocation } from 'wouter';
import { CardTableIcon, SlotMachineIcon } from '@/components/icons';
import { Home, Layers } from 'lucide-react';

export default function NotFound() {
  const [, setLocation] = useLocation();

  return (
    <div style={{
      minHeight: '100vh',
      background: 'radial-gradient(ellipse at 50% 0%, #12063a 0%, #06091a 60%, #000 100%)',
      color: '#fff', fontFamily: "var(--font-body, 'DM Sans', sans-serif)",
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      padding: 24, textAlign: 'center',
      position: 'relative', overflow: 'hidden',
    }}>
      <style>{`
        @keyframes nfFloat { 0%,100%{transform:translateY(0) rotate(0deg);} 50%{transform:translateY(-12px) rotate(5deg);} }
        @keyframes nfGlow { 0%,100%{text-shadow:0 0 40px rgba(119,68,255,0.6);} 50%{text-shadow:0 0 80px rgba(119,68,255,0.9);} }
        @keyframes nfFade { from{opacity:0;transform:translateY(20px);} to{opacity:1;transform:translateY(0);} }
      `}</style>

      {/* Ambient glow rings */}
      {[400, 700].map((s, i) => (
        <div key={s} style={{
          position: 'absolute', top: '40%', left: '50%',
          transform: 'translate(-50%, -50%)',
          width: s, height: s, borderRadius: '50%',
          border: `1px solid rgba(119,68,255,${0.12 - i * 0.04})`,
          pointerEvents: 'none',
        }} />
      ))}

      {/* 404 number */}
      <div style={{
        fontSize: 120, fontWeight: 900, lineHeight: 1,
        background: 'linear-gradient(135deg, #7744ff, #cc88ff, #4422cc)',
        WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
        animation: 'nfGlow 3s ease-in-out infinite',
        marginBottom: 8,
      }}>
        404
      </div>

      {/* SVG card icon — no emoji */}
      <div style={{
        width: 64, height: 64, marginBottom: 20,
        animation: 'nfFloat 3s ease-in-out infinite',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <CardTableIcon size={64} color="rgba(170,102,255,0.85)" />
      </div>

      <div style={{
        fontWeight: 800, fontSize: 22, marginBottom: 8,
        animation: 'nfFade 0.6s ease both',
      }}>
        This Hand Was Folded
      </div>
      <div style={{
        color: 'rgba(200,170,255,0.55)', fontSize: 15,
        lineHeight: 1.6, maxWidth: 320, marginBottom: 36,
        animation: 'nfFade 0.6s 0.1s ease both',
      }}>
        The page you're looking for has left the table. 
        Let's get you back to the action.
      </div>

      <div style={{
        display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center',
        animation: 'nfFade 0.6s 0.2s ease both',
      }}>
        <button
          onClick={() => setLocation('/')}
          style={{
            padding: '13px 28px',
            background: 'linear-gradient(135deg, #7744ff, #4422cc)',
            border: '1px solid rgba(180,120,255,0.4)',
            borderRadius: 12, color: '#fff',
            fontWeight: 800, fontSize: 15, cursor: 'pointer',
            boxShadow: '0 0 24px rgba(119,68,255,0.4)',
            transition: 'transform 0.15s',
            display: 'flex', alignItems: 'center', gap: 8,
          }}
          onMouseEnter={e => (e.currentTarget.style.transform = 'scale(1.04)')}
          onMouseLeave={e => (e.currentTarget.style.transform = 'scale(1)')}
        >
          <Home className="w-4 h-4" /> Go Home
        </button>
        <button
          onClick={() => setLocation('/lobby')}
          style={{
            padding: '13px 28px',
            background: 'rgba(255,255,255,0.06)',
            border: '1px solid rgba(255,255,255,0.12)',
            borderRadius: 12, color: '#ccc',
            fontWeight: 700, fontSize: 15, cursor: 'pointer',
            transition: 'all 0.15s',
            display: 'flex', alignItems: 'center', gap: 8,
          }}
          onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.12)'; e.currentTarget.style.color = '#fff'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.06)'; e.currentTarget.style.color = '#ccc'; }}
        >
          <Layers className="w-4 h-4" /> Open Lobby
        </button>
        <button
          onClick={() => setLocation('/slots')}
          style={{
            padding: '13px 28px',
            background: 'rgba(255,215,0,0.08)',
            border: '1px solid rgba(255,215,0,0.2)',
            borderRadius: 12, color: '#ffd700',
            fontWeight: 700, fontSize: 15, cursor: 'pointer',
            transition: 'all 0.15s',
            display: 'flex', alignItems: 'center', gap: 8,
          }}
          onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,215,0,0.15)'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,215,0,0.08)'; }}
        >
          <SlotMachineIcon size={16} color="#ffd700" /> Try Slots
        </button>
      </div>

      <div style={{ marginTop: 48, color: 'rgba(255,255,255,0.2)', fontSize: 12 }}>
        BetUDontBet Poker · BUDB PKR · GBUX on Solana
      </div>
      <div style={{ marginTop: 12, fontSize: 12 }}>
        <a href="/privacy" style={{ color: 'rgba(170,200,255,0.7)', marginRight: 12 }}>Privacy</a>
        <a href="/terms" style={{ color: 'rgba(170,200,255,0.7)' }}>Terms</a>
      </div>
    </div>
  );
}
